import { 
  Box, 
  Button, 
  Container, 
  Stack, 
  Typography,
  Grid,
  Chip,
  useTheme,
  alpha,
  Avatar
} from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../core/hooks/useStore";
import { RootState } from "../../../core/store/store";
import toolsSlice from "./niche-pig.slice";
import { NichePigRecentSearchesCards } from "./niche-pig-select-recent-searches";

const NichePigDesc = (props: any) => {
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const { apiUrl } = useSelector((state: RootState) => state.home);
  
  const handleOpen = () => {
    dispatch(toolsSlice.actions.setCreateDialogOpened(true));
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box
        sx={{
          textAlign: 'center',
          mb: 4,
          py: 4,
          px: 3,
          background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.05)} 0%, ${alpha(theme.palette.primary.main, 0.02)} 100%)`,
          borderRadius: 4,
          border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`
        }}
      >
        <Avatar
          sx={{
            width: 70,
            height: 70,
            margin: '0 auto',
            mb: 2,
            bgcolor: 'white',
            border: `3px solid ${theme.palette.primary.main}`,
            boxShadow: theme.shadows[3]
          }}
        >
          <TrendingUpIcon 
            sx={{ 
              fontSize: 35, 
              color: theme.palette.primary.main 
            }} 
          />
        </Avatar>

        <Typography 
          variant="h4" 
          sx={{ 
            fontWeight: 700,
            mb: 1.5,
            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }}
        >
          Find Your Next Profitable Niche
        </Typography>
        
        <Typography 
          variant="body1" 
          color="text.secondary" 
          sx={{ mb: 3, maxWidth: 500, mx: 'auto' }}
        >
          Discover low competition, high demand niches with passionate audiences using AI-powered research
        </Typography>

        <Button 
          onClick={handleOpen} 
          variant="contained" 
          size="large"
          startIcon={<AutoAwesomeIcon />}
          sx={{ 
            px: 3,
            py: 1,
            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
            '&:hover': {
              background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
              transform: 'translateY(-2px)',
              boxShadow: theme.shadows[6]
            },
            transition: 'all 0.3s'
          }}
        >
          Start Researching Niches
        </Button>
      </Box>

      <NichePigRecentSearchesCards />
    </Container>
  );
};

export default NichePigDesc;